import axios from "axios";
import { Slide } from "yet-another-react-lightbox";

import { DaySearch, GETFPSummariesResponseBody, DetallesFP, FPConfig, GETFPConfigResponseBody, GeneralConfig } from "./interfaces";

// process.env.NODE_ENV es un string igual a "development" si se abre el
// proyecto con "npm start", "testing" si se usa "npm run test" o
// "production" si se compila con "npm run build".
//
// process.env
let baseURL = "/semaphore";
if (process.env.NODE_ENV !== "production") {
	baseURL = process.env.REACT_APP_LOCAL_BACKEND_URL + baseURL;
}
export { baseURL };

const axiosClient = axios.create({ baseURL: baseURL, withCredentials: true });
// Interceptor para manejar respuestas no autorizadas
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // Token expirado o inválido
      window.location.href = '/login'; // Redirigir a login
    }
    return Promise.reject(error);
  }
);

// App
export function refreshToken() {
	return axiosClient.get(`/refresh_token`);
}

// Página Login
export function postLogin(email: string, password: string) {
	return axiosClient.post(`/login`, { email, password });
}

export function postLogout() {
	return axiosClient.post(`/logout`);
}

// Página Home
export function getFPSummaries(daySearch: DaySearch) {
	return axiosClient.get<GETFPSummariesResponseBody>(
		daySearch.enabled ? `/fp_status?daysAgo=${daySearch.days}` : "/fp_status",
	);
}
export function getGeneralConfig() {
	return axiosClient.get<GeneralConfig>(`/general_config`);
}

export function postGeneralConfig(newConfig: GeneralConfig) {
	return axiosClient.post(`/general_config`, newConfig);
}

export function postAllHeartbeats(newHeartbeat: number) {
	return axiosClient.post("/all_heartbeats", newHeartbeat);
}

// Dashboard
export function getFirmProHistory(nfp: number) {
	return axiosClient.get<DetallesFP>(`/fp_history?nfp=${nfp}`);
}

export function getFPConfig(nfp: number) {
	return axiosClient.get<GETFPConfigResponseBody>(`/fp_config?nfp=${nfp}`);
}

export function postFPConfig(newConfig: FPConfig) {
	return axiosClient.post(`/fp_config`, newConfig);
}

export function getPhotoLinks(nfp: number) {
	return axiosClient.get<Slide[]>(`/photos?nfp=${nfp}`);
}

// export function postSetAlarms(clientID: number, meterID: number, enableAlarms: boolean) {
// 	return axiosClient.post(`/set_alarms`, { clientID, meterID, enableAlarms });
// }